import { FormattedMessage } from "react-intl";

import { Divider } from "@ps-design-system/components/Divider";
import { Text } from "@ps-design-system/components/Text";

import { TAX_DETAILS_STATUS } from "../TaxDetails.consts";
import type { TaxRegistration } from "../TaxDetails.types";

import { TaxDetailsBannerInvalidPopover } from "./TaxDetailsBannerInvalidPopover.tsx";

type TaxDetailsBannerNoteProps = {
  registration: TaxRegistration;
};

/**
 * Renders the VIES registration note, shown only for the invalid status.
 */
const TaxDetailsBannerNote = ({ registration }: TaxDetailsBannerNoteProps) => {
  const { status } = registration;

  if (status !== TAX_DETAILS_STATUS.invalid) {
    return null;
  }

  return (
    <div className="tw-gap-16 tw-flex tw-flex-col">
      <Divider className="tw-m-0" />
      <Text typeface="body-1" className="tw-text-gray-600">
        <FormattedMessage
          id="tax_details.tax_details_banner_note.body"
          defaultMessage="Your VAT ID has the correct format for the selected country, but it couldn't be validated for intra-community (EU-wide) trade via VIES. If you'd like to be VAT-exempt from Peerspace fees, please register your VAT ID with VIES."
        />
      </Text>
      <div className="tw-inline">
        <Text typeface="body-1" className="tw-text-gray-600 tw-inline">
          <FormattedMessage
            id="tax_details.tax_details_banner_note.subtext"
            defaultMessage="How to register your VAT ID with your tax authority"
          />
        </Text>{" "}
        <TaxDetailsBannerInvalidPopover />
      </div>
    </div>
  );
};

export { TaxDetailsBannerNote };
